import axios from "axios";

const actionGetCreators = async ({commit}, payload) => {
  const creators = await axios.get(`${process.env.VUE_APP_URL_API}/v1/people/get_creators`, {params:payload});
  commit("SET_CREATORS", creators.data);
}

const actionSaveCreator = async (_, payload) => {
  await axios.post(`${process.env.VUE_APP_URL_API}/v1/people`, {person:payload});
}

const actionEditCreator = async (_, payload) => {
  await axios.put(`${process.env.VUE_APP_URL_API}/v1/people/${payload.id}`, {person:payload});
}

// CPF/CNPJ no corpo do POST, nunca na URL (G2)
const actionImportJersey = async (_, doc) => {
  const { data } = await axios.post(`${process.env.VUE_APP_URL_API}/v1/integrations/jersey_sync`, {doc});
  return data;
}

export default {
  actionImportJersey,
  actionGetCreators,
  actionSaveCreator,
  actionEditCreator
}